// User agent queries that are used by the recording script.
// TODO(sethf): It would be much better to get tree shaking working and merge
// this with 'index.ts'.

const ua = navigator.userAgent;
export const uaIsIE = ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1;
export const uaIsIE9 = uaIsIE && ua.indexOf('Trident/5') > -1;
export const uaIsIE10 = uaIsIE && ua.indexOf('Trident/6') > -1;
export const uaIsIE11 = uaIsIE && ua.indexOf('rv:11') > -1;
/** note - Chakra engine in Edge browsers identify as "Edge/" and Chromium identify as "Edg/" */
export const uaIsEdgeChakra = ua.indexOf('Edge/') > -1;
export const uaIsOpera = ua.indexOf('Opera/') > -1;
export const uaIsChromeiOS = ua.indexOf('CriOS') > -1; // https://stackoverflow.com/a/13808053
export const uaIsSnap = ua.indexOf('Snapchat') > -1; // Snapchat

// source: https://stackoverflow.com/a/10170885
const isIOSWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent);
// copied from https://stackoverflow.com/a/23522755/58737
const isSafari = /^((?!chrome|android).)*(safari)/i.test(window.navigator.userAgent);
/** return true if browse is safari or if an iOS webview */
export const uaIsSafari = isIOSWebView || isSafari;

function getSafariVersion(): number {
  const match = window.navigator.userAgent.match(/Version\/(\d+)/);
  return match && match[1] ? parseInt(match[1], 10) : -1;
}

function isSafariVersionX(x: number): boolean {
  if (!uaIsSafari) {
    return false;
  }
  const safariVersion = getSafariVersion();
  return safariVersion >= 0 && safariVersion === x;
}

function isSafariBeforeVersionX(x: number): boolean {
  if (!uaIsSafari) {
    return false;
  }
  const safariVersion = getSafariVersion();
  return safariVersion >= 0 && safariVersion < x;
}

export const isSafari9 = isSafariVersionX(9);
export const isSafari10 = isSafariVersionX(10);
export const isSafariBefore8 = isSafariBeforeVersionX(8);
export const isSafariBefore10 = isSafariBeforeVersionX(10);
export const isSafariBefore12 = isSafariBeforeVersionX(12);

export type uaPrefix = 'webkit' | 'moz' | 'ms';

// convenience method to check for property existence, providing fallback to ua prefixed versions
// browsers follow conventions for prefixed property names:
// - camelcase starting with prefix if a property e.g. webkitFullscreenElement
// - lowercase starting with 'on' then prefix if an event e.g. onwebkitfullscreenchange
export function uaPrefixedPropety(target: Node, name: string) {
  const isEvent = name.indexOf('on') === 0;
  const keyTransformer = isEvent
    ? (p: uaPrefix) => `on${p}${name.slice(2)}`
    : (p: uaPrefix) => `${p}${name.charAt(0).toUpperCase()}${name.slice(1)}`;

  const keys = [
    () => name,
    () => keyTransformer('webkit'),
    () => keyTransformer('moz'),
    () => keyTransformer('ms'),
  ];
  for (const key of keys) {
    const prop = key();
    if (prop in target) {
      return prop;
    }
  }
  return name;
}
